import { createFileRoute, redirect } from "@tanstack/react-router"

export const Route = createFileRoute("/$organisation/")({
  beforeLoad: ({ params }) => {
    throw redirect({
      to: "/$organisation/dashboard",
      params: { organisation: params.organisation },
    })
  },
})
